import {
  Link,
  useParams,
  useRouteMatch,
} from 'react-router-dom/cjs/react-router-dom.min';
import { logOut, openSideNav, registerRoutes } from '../../../func';
import { useCallback, useEffect, useMemo, useState } from 'react';
import Axios from 'axios';
import GeneralTab from './generalTab';
import AddressTab from './addressTab';
import PharmaciesTab from './pharmaciesTab';

const BuyingGroupDetail = () => {
  const { path } = useRouteMatch();
  const { id } = useParams();
  const authData = useMemo(
    () => JSON.parse(localStorage.getItem('auth_data')),
    []
  );

  const tabs = useMemo(() => ['General', 'Address', 'Pharmacies'], []);

  const [isLoading, setisLoading] = useState(false);
  const [buyingGroup, setBuyingGroup] = useState(undefined);
  const [activeTab, setActiveTab] = useState('General');

  const networkCalls = useMemo(
    () =>
      registerRoutes(
        {
          getBuyingGroup: {
            func: buyingGroupId => {
              setisLoading(true);
              Axios.get('/api/v2/buyinggroup/read/one/by/id', {
                params: {
                  ...authData,
                  buyingGroupId,
                },
              })
                .then(result => setBuyingGroup(result.data))
                .catch(logOut)
                .finally(() => setisLoading(false));
            },
            type: 'r',
          },
        },
        path
      ),
    [path, authData]
  );

  useEffect(() => {
    if (!id) return;
    networkCalls.getBuyingGroup(id);
  }, [networkCalls, id]);

  const getContent = useCallback(() => {
    switch (activeTab) {
      case 'General':
        return (
          <GeneralTab
            buyingGroup={buyingGroup}
            refetch={() => networkCalls.getBuyingGroup(id)}
          />
        );
      case 'Address':
        return (
          <AddressTab
            buyingGroup={buyingGroup}
            refetch={() => networkCalls.getBuyingGroup(id)}
          />
        );
      case 'Pharmacies':
        return <PharmaciesTab buyingGroup={buyingGroup} />;
      default:
        return null;
    }
  }, [activeTab, id, buyingGroup]);

  return (
    <div className="main">
      <div className="row">
        <div style={{ display: 'flex' }}>
          <Link to="/" onClick={openSideNav} style={{ marginRight: '12px' }}>
            <i className="material-icons black-text">menu</i>
          </Link>
          <Link to="/">Home</Link>
          <i className="material-icons">chevron_right</i>
          <Link to="/buyinggroup">Buying Groups</Link>
          <i className="material-icons">chevron_right</i>
          <span className="grey-text">
            {buyingGroup?.name.toLocaleUpperCase() || 'Buying Group Detail'}
          </span>
        </div>
      </div>
      <div className="row">
        <div className="col s4 m3 l2">
          <ul className="collection">
            {tabs.map(t => (
              <li
                key={t}
                id={`tab-${t}`}
                className={`collection-item ${activeTab === t ? 'blue white-text' : ''}`}
                onClick={() => setActiveTab(t)}
                style={{ cursor: 'pointer' }}
              >
                {t}
              </li>
            ))}
          </ul>
        </div>
        <div className="col s8 m9 l10">
          {isLoading ? (
            <div className="progress">
              <div className="indeterminate blue" />
            </div>
          ) : (
            getContent()
          )}
        </div>
      </div>
    </div>
  );
};

export default BuyingGroupDetail;
